module.exports = __webpack_public_path__ + "img/logo-loja-vasco.fc262d4e.svg";